import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=5e2dfc75"
import script from "./Marketing.vue?vue&type=script&lang=js"
export * from "./Marketing.vue?vue&type=script&lang=js"
import style0 from "./Marketing.vue?vue&type=style&index=0&id=5e2dfc75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports